<div id="campaignDonationsReport" style="display:none;margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="row" style="margin-bottom: 20px">
            <div class="col">
                <h5><a id="goToAllCampaigns" routerLink="/reports/campaign">All Campaigns/</a><span id="campaignNameDonations"></span></h5>
            </div>
        </div>
    
        <div class="table--paybee">
            <div class='text-center no-data-text' style="display: none" id="emptyCampaignDonationsList">No transactions yet.</div>
            <table id ="campaignDonationsList" class="table" cellspacing="0" style="width: 100%;">
                <thead class="thead-light">
                <tr id="campaignDonationColumns">
                    <th>Name</th>
                    <th>Email</th>
                    <th class="text-nowrap">First Name</th>
                    <th class="text-nowrap">Last Name</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Option </th>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Tax</th>
                    <th>Date </th>
                    <th>Method</th>
                    <th>
                        <div class="d-flex align-items-center">
                            Info
                            <span data-toggle='popover-hover-table'
                                data-trigger='hover'
                                data-placement='right'
                                title='{{selectedCampaign?.additionalInfoDesc}}'
                                class='ml-1'>
                                <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                            </span>
                        </div>
                    </th>
                    <th class="text-nowrap">
                        <div class="d-flex align-items-center text-nowrap">
                            Info Selected
                            <span data-toggle='popover-hover-table'
                                data-trigger='hover'
                                data-placement='right'
                                title='{{selectedCampaign?.additionalInfoSelectDesc}}'
                                class='ml-1'>
                                <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                            </span>
                        </div>
                    </th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="table--paybee">
            <div class='text-center no-data-text' style="display: none" id="emptyCampaignPendingList">No transactions yet.</div>
            <table id ="campaignPendingList" class="table" cellspacing="0" style="width: 100%;">
                <thead class="thead-light">
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Option </th>
                    <th>Status</th>
                    <th>Amount</th>
                    <th>Date </th>
                    <th>Action</th>
                </tr>
                </thead>
            </table>
        </div>
    </div>
</div>